import { GridIcon, HomeIcon, PersonIcon, ReaderIcon } from '@radix-ui/react-icons';

/** The same navigation moves from the header to a safe-area-aware mobile dock. */
export function StudentHomeNavigation({
  disabled,
  onOpenEbooks,
  onOpenPractice,
}: {
  readonly disabled: boolean;
  readonly onOpenEbooks?: (() => void) | undefined;
  readonly onOpenPractice?: (() => void) | undefined;
}) {
  return (
    <nav className="student-home-nav" aria-label="学生首页导航">
      <a
        href="#student-home-heading"
        aria-current="page"
        aria-disabled={disabled}
        tabIndex={disabled ? -1 : undefined}
        onClick={(event) => {
          if (disabled) event.preventDefault();
        }}
      >
        <HomeIcon aria-hidden="true" />
        <span>首页</span>
      </a>
      <a
        href="#student-home-games"
        aria-disabled={disabled}
        tabIndex={disabled ? -1 : undefined}
        onClick={(event) => {
          if (disabled) event.preventDefault();
        }}
      >
        <PersonIcon aria-hidden="true" />
        <span>对弈</span>
      </a>
      {onOpenEbooks ? (
        <button type="button" disabled={disabled} onClick={onOpenEbooks} aria-label="导航：题书">
          <ReaderIcon aria-hidden="true" />
          <span>题书</span>
        </button>
      ) : null}
      {onOpenPractice ? (
        <button type="button" disabled={disabled} onClick={onOpenPractice} aria-label="导航：摆棋">
          <GridIcon aria-hidden="true" />
          <span>摆棋</span>
        </button>
      ) : null}
    </nav>
  );
}
